import Card from "components/card";
import { Avatar } from "antd";




const SummaryCard = ({title, displayCount, icon, statusTag, description, textColor="text-white" }) => {
  return (
    <Card className="bg-white rounded-[20px] p-2 border">

      <div className="flex justify-between px-3 pt-2">
          <h4 className="card-title">
            {title}
          </h4>

          <div className="mt-1">
            {icon}
          </div>
      </div>

      <div className="mb-auto  w-full flex-col px-3 pt-2 mt-4 ">
        <div className={`text-[24px] flex font-semibold ${textColor} leading-none items-center space-x-2`}>
          <span>{displayCount}</span>

          {statusTag && (
            <span className="flex items-center bg-blue-50 text-blue-700 text-xs font-medium px-2 py-1 rounded-full">
              {statusTag}
            </span>
          )}
        </div>

        <div className="text-sm mt-1">
          {description}
        </div>
      </div>

    </Card>
    
  );
};

export default SummaryCard;
